import { isSafeUrl } from '@atlaskit/adf-schema/url';
export const validatorFnMap = {
  safeUrl: isSafeUrl
};